import { render, staticRenderFns } from "./showonedocument.vue?vue&type=template&id=564eaf18&"
import script from "./showonedocument.vue?vue&type=script&lang=js&"
export * from "./showonedocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports